// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--31LQy";
export var footerTexture = "Footer-module--footerTexture--q0x4j";
export var logo = "Footer-module--logo--1Izfc";
export var footerTexts = "Footer-module--footerTexts--3_CEi";
export var message = "Footer-module--message--1LBUz";